export default __webpack_public_path__ + "8a1fb1322358dbe0aeb6f9f639a27a62.svg";